module.exports = __webpack_public_path__ + "static/media/website-setp-img-1.b0693ea0.png";